<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Produtos">
      <b-row class="mb-5">
        <b-col cols="12" sm="7" class="mb-2">
          <Search @changeSearchValue="searchValue = $event" />
        </b-col>
        <b-col>
          <b-row class="justify-content-end mr-1">
            <b-col cols="auto">
              <b-button
                variant="outline-secondary"
                @click="addNewProduct()"
                class="mr-3"
              >
                <b-icon icon="plus-circle-fill"></b-icon> Adicionar
              </b-button>
              <b-button variant="outline-secondary" @click="exportPDF()">
                <b-icon icon="download"></b-icon> Exportar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-container fluid>
        <div class="scrollable-area">
          <CardList :cards="products" :searchValue="searchValue" />
        </div>
      </b-container>
      <ModalAddProduct />
    </Dashboard>
  </div>
</template>

<script>
/* eslint-disable global-require */
/* eslint-disable new-cap */
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import Dashboard from '../components/Dashboard.vue';
import HeaderVue from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';
import Search from '../components/Search.vue';
import CardList from '../components/Products/CardList.vue';
import ModalAddProduct from '../components/Products/ModalAddProduct.vue';
import MixinExportPDF from '../utils/MixinExportPDF';
import { Products } from '../services/Product';
import showError from '../utils/showError';

export default {
  components: {
    HeaderVue,
    Sidebar,
    Dashboard,
    Search,
    CardList,
    ModalAddProduct,
  },
  mixins: [MixinExportPDF],
  data() {
    return {
      searchValue: '',
      products: [],
    };
  },

  methods: {
    addNewProduct() {
      this.$bvModal.show('modal-add-product');
    },

    addTablePDF(doc) {
      const startY = 90;

      const head = [
        [
          { content: ' ', rowSpan: 1 },
          { content: 'PRODUTO', rowSpan: 1 },
          { content: 'DESCRIÇÃO', rowSpan: 1 },
        ],
      ];
      const body = [];

      this.products.forEach((product) => {
        body.push([product.image, product.type, product.description]);
      });

      doc.autoTable({
        head,
        body,
        startY,
        theme: 'grid',
        headStyles: {
          fontSize: 12,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.26,
          lineColor: '#B6B6B6',
          halign: 'center',
          valign: 'middle',
        },
        columnStyles: {
          0: {
            halign: 'center',
            cellWidth: 40,
            minCellHeight: 30,
            lineColor: '#B6B6B6',
            textColor: [0, 0, 0],
            valign: 'middle',
          },
          1: {
            halign: 'center',
            cellWidth: 50,
            lineColor: '#B6B6B6',
            textColor: [0, 0, 0],
            valign: 'middle',
          },
          2: {
            halign: 'center',
            cellWidth: 95,
            lineColor: '#B6B6B6',
            textColor: [0, 0, 0],
            valign: 'middle',
          },
        },

        // Coloca a imagem do produto na primeira coluna
        didDrawCell(data) {
          if (data.column.index === 0 && data.cell.section === 'body') {
            if (data.cell.raw === null) return;
            const imageUrl = `${data.cell.raw}`;
            const textPos = data.cell;

            doc.setFillColor(255, 255, 255);
            doc.rect(textPos.x, textPos.y, textPos.width, textPos.height, 'F');

            // Adiciona imagem na tabela
            doc.addImage(imageUrl, textPos.x, textPos.y, 40, 30);
          }
        },
      });
      return doc;
    },

    async exportPDF() {
      const doc = new jsPDF();

      // Adiciona a logomarca
      let imageUrl = require('../assets/logo.jpg');
      let response = await fetch(imageUrl);
      let blob = await response.blob();
      let blobUrl = URL.createObjectURL(blob);
      doc.addImage(blobUrl, 'JPEG', 14, 3, 50, 25);

      // Libera a URL do Blob
      URL.revokeObjectURL(blobUrl);

      this.addHeaderPDF(doc);
      this.addTitlePDF(doc, 'Produtos', 'Disponíveis');
      this.addTablePDF(doc);

      // Adiciona imagem Fale conosco após a tabela
      imageUrl = require('../assets/faleConosco.jpg');
      response = await fetch(imageUrl);
      blob = await response.blob();
      blobUrl = URL.createObjectURL(blob);
      doc.addImage(blobUrl, 'JPEG', 125, 250, 80, 40);

      // Salva o documento com um nome específico
      doc.save('Produtos.pdf');
    },
  },
  created() {
    Products()
      .then((response) => {
        this.products = response.data.map((product) => ({
          ...product,
        }));
      })
      .catch(showError);
  },
};
</script>

<style scoped></style>
